/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum HDML_TAG_NAMES {
  CONNECTION = "hdml-connection",
  FRAME = "hdml-frame",
  MODEL = "hdml-model",
  TABLE = "hdml-table",
  JOIN = "hdml-join",
  CONNECTIVE = "hdml-connective",
  FILTER_BY = "hdml-filter-by",
  FILTER = "hdml-filter",
  GROUP_BY = "hdml-group-by",
  SPLIT_BY = "hdml-split-by",
  SORT_BY = "hdml-sort-by",
  FIELD = "hdml-field",
}
